import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const MetaInfo = props => {
  return (
    <Fragment>
      <h3>Meta Info</h3>
      <ul>
        <li>
          <b>Log ID:</b> {props.log.id}
        </li>
        <li>
          <b>LTI Message Type:</b> {props.log.params.lti_message_type}
        </li>
        <li>
          <b>LTI Version:</b> {props.log.params.lti_version}
        </li>
      </ul>
    </Fragment>
  )
}
export default MetaInfo

MetaInfo.propTypes = {
  log: PropTypes.object,
}
